import { Box, Stack } from '@mui/material';

import { CheckIcon } from '@occc/ui-design-system';

import { OfferMemberProgress } from '../in-progress-offers.types';

export const Punches = ({ required, achieved }: OfferMemberProgress) => {
  return (
    <Stack direction='row' flexWrap='wrap' rowGap={1} gap={2}>
      {Array.from({ length: required }, (_value, index) => {
        const isActive = achieved > index;

        return (
          <Box
            key={index}
            display='flex'
            alignItems='center'
            justifyContent='center'
            borderRadius='50%'
            width={20}
            height={20}
            color={(theme) =>
              isActive ? theme.palette.primary.contrastText : theme.palette.text.disabled
            }
            bgcolor={(theme) => (isActive ? theme.palette.primary.main : theme.palette.divider)}
          >
            {isActive && <CheckIcon sx={{ width: 12 }} />}
          </Box>
        );
      })}
    </Stack>
  );
};
